// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3DkAC","emails":"CreateEditClinics_emails__21oLg","emailTagLabel":"CreateEditClinics_emailTagLabel__1p3Mq"};